import { parcentFromPos, pxFromParcent } from "../domain/posDomain"

export class GraphUseCase {
  constructor(width, height, scaleSpace, rightTop, leftBottom,xLabel,yLabel) {
    this.width = width;
    this.height = height;
    this.scaleSpace = scaleSpace;
    this.rightTop = rightTop;
    this.leftBottom = leftBottom;
    this.xLabel = xLabel;
    this.yLabel = yLabel;
  }

  parcentFromPos(x, y) {
    return parcentFromPos(x, y, this.leftBottom, this.rightTop,this.xLabel.isLog,this.yLabel.isLog);
  }

  pxFromParcent(parcent) {
    return pxFromParcent(this.width, this.height, parcent, this.scaleSpace);
  }

  posToPx(x, y) {
    return this.pxFromParcent(this.parcentFromPos(x, y));
  }

  posToPxWithScaleSpace(x, y) {
    return this.posToPx(x, y);
  }

  isInsideCanvas(x, y) {
    const { x: px, y: py } = this.posToPx(x, y);
    return px >= this.scaleSpace && px <= this.width + this.scaleSpace && py >= 0 && py <= this.height;
  }
}